/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import { useTheme } from '../../../utils/ThemeColorContext'
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
// import { conversionAPI } from '../../../redux/Actions/postMethods'

import PrimaryButton from '../../../components/buttons/PrimaryButton'
import CheckInformationWrapper from '../CheckInformationWrapper'
import DefaultPage from '../DefaultPage'
import Image1 from '../../../assets/images/Image.png'
import Image2 from '../../../assets/images/Image (1).png'
import { getDecision, getIntercomHashUser, } from '../../../redux/Actions/getMethods'
import SpinnerLarge from '../../../components/SpinnerLarge'
import ContentBankCard from '../../../components/cards/ContentBankCard'
import AddAccount from '../../../components/cards/AddAccount'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import { useState } from 'react'
import numeral from 'numeral'
import { silentLogout } from '../../../App'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { InfoIcon } from '../../../assets/AppIcons'

const Decision = () => {
  const dispatch = useDispatch()
  const { loading } = useSelector(
    (state) => state.dataReducer,
  )
  const { color, isSmallScreen } = useTheme()
  const [actionToken, setActionToken] = useState(null)
  const [err, setErr] = useState('')
  const [decision, setDecision] = useState(null)
  const [reapplyInDays, setReapplyInDays] = useState(null)
  const [accounts, setAccounts] = useState([])
  const ldClient = useLDClient()
  
  const navigate = useNavigate()

  useEffect(() => {
    if (decision?.application?.status && !["REFERRED", "DECLINED", "APPROVED"].includes(decision?.application?.status)) {
      dispatch({ type: ActionTypes.OPEN_LOGIN_MODAL })
      const payload = {
        email: decision?.email,
      }
      dispatch({ type: ActionTypes.LOGIN_WITH_VALUES, payload: payload })
      navigate('/address-detail')
    }
  }, [decision?.application?.status])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const applicationId = params.get('id')
    const decisionToken = params.get('decision_token')
    const actionTokenParam = params.get('action_token')
    if (!applicationId || !decisionToken) {
      navigate('/address-detail')
      return
    }
    setActionToken(actionTokenParam)
    
    const getData = async () => {
      await silentLogout(ldClient)
      const res = await dispatch(getDecision(applicationId, decisionToken))
      switch (res?.status) {
        case 200: {
          if (res?.data?.reapply) {
            const providedDate = new Date(res?.data?.reapply)
            const currentDate = new Date()
            const differenceInMilliseconds = providedDate.getTime() - currentDate.getTime()
            const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24))
            setReapplyInDays(differenceInDays)
          }
          setDecision(res?.data)
          if (res?.data?.accounts) {
            const accounts = res?.data?.accounts
            const unexpiredAccounts = (accounts ? accounts : []).filter(account => (account?.days_to_renew ? account?.days_to_renew : 0) > 0)
            setAccounts(unexpiredAccounts ? unexpiredAccounts : [])
          }
          getIntercomHashUser(decisionToken)
          break
        }
        default:
          setErr("Please sign in to continue")
          break
      }
    }

    getData()
  }, [])

  const toApprovedContinue = async () => {
    if (decision?.must_set_password == true) {
      dispatch({ type: ActionTypes.OPEN_LOGIN_MODAL })
      const payload = {
        email: decision?.email,
        actionToken: actionToken,
        navigateToAfterLogin: '/customise-loan',
      }
      dispatch({ type: ActionTypes.LOGIN_WITH_VALUES, payload: payload })
    } else {
      dispatch({ type: ActionTypes.OPEN_LOGIN_MODAL })
      const payload = {
        email: decision?.email,
        actionToken: actionToken,
      }
      dispatch({ type: ActionTypes.LOGIN_WITH_VALUES, payload: payload })
    }
  }

  const goToAddBankAccount = () => {
    if (decision && actionToken) {
      localStorage.removeItem(`bankConfirm-${decision?.email}`)
      localStorage.removeItem(`add_accounts-${decision?.email}`)
      localStorage.setItem(`add-another-bank-account-${decision?.email}`, true)
      dispatch({ type: ActionTypes.OPEN_LOGIN_MODAL })
      const payload = {
        email: decision?.email,
        actionToken: actionToken,
        navigateToAfterLogin: '/verify-income',
      }
      dispatch({ type: ActionTypes.LOGIN_WITH_VALUES, payload: payload })
    } else {
      setErr("Please sign in to continue")
    }
  }

  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true)
    }, 0)
    return () => clearTimeout(timer)
  }, [])

  return (
    <DefaultPage>
      {err ? (
        <div className="h-full flex flex-col items-center justify-center space-y-10 ">
          <div className={"h-px"} />
          <CheckInformationWrapper img={null}>
            <div className="w-full space-y-8 md:space-y-10">
              <div className="flex flex-col items-center space-y-4 md:space-y-6 md:pb-[0px]">
                <h1
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.Title1,
                          color: color.Plum,
                        }
                      : {
                          ...AppStyles.LargeTitle2,
                          color: color.Plum,
                        }
                  }
                  className="text-center"
                >
                  {err}
                </h1>
              </div>
              <div
                style={{
                  marginTop: isSmallScreen ? '40px' : '24px',
                  width: '100%',
                }}
              >
                <PrimaryButton
                  text={'Login'}
                  id={'login-button'}
                  onClick={async () => {
                    dispatch({ type: ActionTypes.OPEN_LOGIN_MODAL })
                  }}
                  className={'w-full mb-[8px]'}
                />
              </div>
            </div>
          </CheckInformationWrapper>
        </div>
      ) : (
        <>
          {(!decision || loading) ? (
            <SpinnerLarge />
          ) : decision?.application?.status === 'REFERRED' ? (
            <div className="md:flex-col md:w-[456px] md:m-[auto] py-8 md:py-0 px-0 space-y-4 items-center">
              <div className="px-8">
                <CheckInformationWrapper img={Image1}>
                  <div className="w-full space-y-8 md:space-y-10">
                    <div className="flex flex-col items-center space-y-4 md:space-y-6 md:pb-[36px]">
                      <h1
                        style={
                          isSmallScreen
                            ? {
                                ...AppStyles.Title1,
                                color: color.Plum,
                              }
                            : {
                                ...AppStyles.LargeTitle2,
                                color: color.Plum,
                              }
                        }
                        className="text-center"
                      >
                        We’re{' '}
                        <span
                          style={
                            isSmallScreen
                              ? { ...AppStyles.Title1, color: color.Yellow }
                              : { ...AppStyles.LargeTitle2, color: color.Yellow }
                          }
                        >
                          Checking
                        </span>{' '}
                        Your Information Now!
                      </h1>
                      <p
                        style={
                          isSmallScreen
                            ? {
                                ...AppStyles.Body,
                                color: color.Grey,
                              }
                            : {
                                ...AppStyles.Body16,
                                color: color.Grey,
                              }
                        }
                        className="text-center"
                      >
                        Our underwriting team are looking at your application now,
                        they'll reach out to you with anything they require or a
                        decision via email.
                      </p>
                    </div>
                  </div>
                </CheckInformationWrapper>
              </div>
              <div
                style={{
                  backgroundColor: color.White,
                }}
                className={` ${isSmallScreen ? 'px-0 py-8 space-y-6 md:w-[456px]' : 'px-0 py-8 rounded-3xl space-y-6 md:w-[456px]'}`}
              >
                <div 
                  className="flex-col items-center justify-center md:w-[456px] md:m-[auto] px-8"
                >
                  <div className=" space-y-6">
                    <p
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Body,
                              color: color.Grey,
                            }
                          : {
                              ...AppStyles.Body16,
                              color: color.Grey,
                            }
                      }
                      className="text-center"
                    >
                      We'll verify your income using the account(s) below
                    </p>
                    <div className=" grid grid-cols-1  gap-6  ">
                      {accounts?.map((bank, index) => (
                        <div key={index}>
                          <ContentBankCard
                            selectedBank={bank}
                            isSelected={false}
                          />
                        </div>
                      ))}
                      <div className={`fade-in ${visible ? 'visible' : ''}`}>
                        { visible && (
                          <AddAccount
                            onClick={() => {
                              if (visible) {
                                goToAddBankAccount()
                              }
                            }}
                            title="If you’ve been asked by our underwriters to connect another account, or haven't connected the accounts you receive your income into, you can do that here."
                            switched={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : decision?.application?.status === 'DECLINED' ? (
            <div className="h-full flex flex-col items-center justify-center space-y-10 ">
              <div className={"h-px"} />
              <CheckInformationWrapper img={null}>
                <div className="w-full space-y-8 md:space-y-10">
                  <div className="flex flex-col items-center space-y-0 md:space-y-0 ">
                    <h1
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Title1,
                              color: color.Plum,
                            }
                          : {
                              ...AppStyles.LargeTitle2,
                              color: color.Plum,
                            }
                      }
                      className="text-center"
                    >
                      {decision?.first_name ? `Sorry, ${decision?.first_name}` : 'Sorry'}
                    </h1>
                    <h1
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Title2,
                              color: color.Blurple,
                              paddingTop: '8px',
                            }
                          : {
                              ...AppStyles.Title1,
                              color: color.Blurple,
                              paddingTop: '8px',
                            }
                      }
                      className="text-center"
                    >
                      Unfortunately we can't offer<br/>you a loan at this time.
                    </h1>
                  </div>
                </div>
                { reapplyInDays && (
                  <div className="flex flex-col w-full pt-8 space-y-0 items-center">
                    <div className="flex flex-col w-full items-center space-y-6">
                      <div
                        className="flex justify-center w-full rounded-[12px]"
                        style={{
                          background: 'rgba(93, 28, 211, 0.05)',
                          padding: '20px 16px 16px 16px',
                        }}
                      >
                        <span className="reapplyin"> You can reapply in</span>
                        <span className="days_90">
                          {reapplyInDays ? reapplyInDays || '-' : '-'} days
                        </span>
                      </div>
                      <div className="h-px"/>
                    </div>
                  </div>
                )}
              </CheckInformationWrapper>
            </div>
          ) : decision?.application?.status === 'APPROVED' ? (
            <div className="md:flex md:w-[792px] m-[auto] pt-8 md:pt-0">
              <CheckInformationWrapper img={Image2}>
                <div className=" w-full space-y-8 md:space-y-10  ">
                  <div className="space-y-4 md:space-y-6 ">
                    <h1
                      style={
                        isSmallScreen
                          ? {
                              ...AppStyles.Title1,
                              color: color.Plum,
                              lineHeight: '32px',
                              margin: 0,
                              padding: 0,
                            }
                          : {
                              ...AppStyles.LargeTitle2,
                              color: color.Plum,
                            }
                      }
                      className="text-center"
                    >
                      You’re&nbsp;
                      <span
                        style={
                          isSmallScreen
                            ? { ...AppStyles.Title1, color: color.Teal }
                            : { ...AppStyles.LargeTitle2, color: color.Teal }
                        }
                      >
                        Approved
                      </span>{' '}
                      for <br /> an Updraft loan
                    </h1>
                    {decision && decision?.original_offer_limit && decision?.application?.max_amount && decision?.original_offer_limit > decision?.application?.max_amount && (
                      <p style={{ ...AppStyles.Title1, color: color.Blurple, textAlign: 'center' }}>
                        It’s a little lower than what you applied for, but we wanted to make sure your monthly repayments are affordable.
                      </p>
                    )}
                    <Fields decision={decision} />
                    {decision && decision?.application && decision?.application.fee_percentage && decision?.application.fee_percentage > 0.0 && (
                      <div
                        style={{
                          marginTop: '24px',
                          backgroundColor: color.White,
                          borderColor: color.MidGrey,
                          minHeight: isSmallScreen && '74px',
                          alignItems: !isSmallScreen && 'flex-start',
                          // justifyContent: 'center',
                        }}
                        className="p-4 border rounded-2xl flex space-x-4"
                      >
                        <div>
                          <InfoIcon fill={color.BlurpleTeal} />
                        </div>
                        <p style={{ ...AppStyles.Body12Demi, color: color.Grey }}>
                          Your loan fee is {decision?.application?.fee_percentage * 100}% of
                          the amount you borrow. It is included in your monthly repayments
                          and it is spread evenly over the term of your loan.
                        </p>
                      </div>
                    )}
                    {isSmallScreen && (
                      <div style={{ marginTop: '32px' }}>
                        <PrimaryButton
                          id={'customise-loan-approved'}
                          text={'Continue'}
                          onClick={toApprovedContinue}
                        />
                      </div>
                    )}
                  </div>
                  {!isSmallScreen && (
                    <div className=" space-y-2">
                      <PrimaryButton
                        id={'customise-loan-approved'}
                        text={'Continue'}
                        onClick={toApprovedContinue}
                      />
                    </div>
                  )}
                </div>
              </CheckInformationWrapper>
            </div>
          ) : null}
        </> 
      )}
    </DefaultPage>
  )
}

const Fields = ({decision}) => {
  const { color, isSmallScreen } = useTheme()

  return (
    <div
      style={{
        backgroundColor: color.LightGrey,
        margin: isSmallScreen && 0,
        marginTop: isSmallScreen && '16px',
      }}
      className="w-full rounded-2xl "
    >
      {decision?.application?.fee_percentage && decision?.application?.fee_percentage > 0.0 ? (
        <>
          <div
            style={{ borderColor: color.MidGrey }}
            className="cardBody  border-b h-[56px]"
          >
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.Plum,
                lineHeight: '24px',
              }}
            >
              Your offer
            </p>
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.BlurpleTeal,
              }}
            >
              £
              {decision?.application?.max_amount
                ? numeral(decision?.application?.max_amount).format('0,0')
                : 0}{' '}
            </p>
          </div>
          <div
            style={{ borderColor: color.MidGrey }}
            className="cardBody border-b  h-[56px]"
          >
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.Plum,
                lineHeight: '24px',
              }}
            >
              Annual interest rate
            </p>
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.BlurpleTeal,
              }}
            >
              {!decision?.application?.interestRate
                ? 0
                : (decision?.application?.interestRate * 100).toFixed(2)}
              %
            </p>
          </div>
          <div className="cardBody ">
            <div>
              <p
                style={{
                  ...AppStyles.BodyBold,
                  color: color.Plum,
                  lineHeight: '24px',
                }}
              >
                Loan fee
              </p>
              <p
                style={{
                  ...AppStyles.Caption1,
                  color: color.Grey,
                  lineHeight: '24px',
                }}
              >
                Split over the term of your loan
              </p>
            </div>

            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.BlurpleTeal,
              }}
            >
              £
              {!decision?.application?.fee_percentage
                ? 0
                : Math.ceil(decision?.application?.fee_percentage *
                  decision?.application?.min_amount)}
            </p>
          </div>
        </>
      ) : (
        <>
          <div
            style={{ borderColor: color.MidGrey, height: '56px' }}
            className="cardBody  border-b"
          >
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.Plum,
                lineHeight: '24px',
              }}
            >
              Your offer
            </p>

            <p style={{ ...AppStyles.BodyBold, color: color.BlurpleTeal }}>
              £
              {decision?.application?.max_amount
                ? numeral(decision?.application?.max_amount).format('0,0')
                : 0}{' '}
            </p>
          </div>
          <div style={{ borderColor: color.MidGrey }} className="cardBody   ">
            <p
              style={{
                ...AppStyles.BodyBold,
                color: color.Plum,
                lineHeight: '24px',
              }}
            >
              Annual Interest Rate
            </p>
            <p style={{ ...AppStyles.BodyBold, color: color.BlurpleTeal }}>
              {!decision?.application?.interestRate
                ? 0
                : (decision?.application?.interestRate * 100).toFixed(2)}
              %
            </p>
          </div>
        </>
      )}
    </div>
  )
}

export default Decision
